import type {
  ICostCardManagementModel,
  ICostCardManagementStore,
} from '@monorepo/types/document/costCard/costCardManagement.type';
import { tableUpdate } from '@monorepo/utils';

const initState: ICostCardManagementStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    location_id: '',
    offset: 0,
    limit: 50,
  },
  treeList: [], // 新增 treeList 初始值为空数组
};

const CostCardManagementStore: ICostCardManagementModel = {
  namespace: 'costCardManagementStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return { ...state, tableList };
    },
    // 新增 setTreeList reducer
    setTreeList(state, { payload }) {
      return {
        ...state,
        treeList: payload, // 将 payload 中的值设置为 treeList
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default CostCardManagementStore;
